import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, Autoplay } from 'swiper/modules';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const MySlider = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await fetch(`${API_URL}/api/gallery/`);
        if (!res.ok) throw new Error('Failed to fetch images');
        setImages(await res.json());
      } catch (e) {
        setError('Failed to load images');
      }
      setLoading(false);
    };
    fetchImages();
  }, []);

  // Add CSS for arrow styling
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .swiper-button-next,
      .swiper-button-prev {
        color: var(--primary) !important;
      }
      .swiper-button-next:after,
      .swiper-button-prev:after {
        font-size: 24px;
        font-weight: bold;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  if (loading) return <div style={{ textAlign: 'center', padding: '40px' }}>Loading...</div>;
  if (error) return <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>{error}</div>;
  if (!images.length) return <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>No images found</div>;

  return (
    <Swiper
      modules={[Navigation, Autoplay]}
      navigation={true}
      loop={true}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      spaceBetween={0}
      breakpoints={{
        320: { slidesPerView: 1 },
        480: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
        1280: { slidesPerView: 5 },
      }}
    >
      {images.map((img, index) => (
        <SwiperSlide key={img.id || index}>
          <div style={{ height: '350px', padding: '4px' }}>
            <img
              src={img.image}
              alt={img.caption}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '4px',
              }}
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default MySlider;